import { FC } from 'react';
import styled from 'styled-components';
import { RiFileExcel2Line } from 'react-icons/ri';

interface IProps {
  className: string;
  onClick?: (e?: any) => void;
  onClickCapture?: (e: any) => void;
  text: string;
  disabled?: boolean;
  isLoading?: boolean;
  writeAuthYn?: 'Y' | 'N';
  value?: string;
  useExcelIcon?: boolean;
  style?: object;
}
const Block = styled.a`
  .btn-w40p {
    width: 40px;
  }

  .btn-w55p {
    width: 55px;
  }

  .btn-w70p {
    width: 70px;
  }

  .btn-w92p {
    width: 92px;
  }

  .btn-w100p {
    width: 100px;
  }

  .btn-w130p {
    width: 130px;
  }

  .btn-w150p {
    width: 150px;
  }

  .btn-wh62p {
    width: 62px;
    height: 62px;
  }

  .btn-wh70p {
    width: 70px;
    height: 70px;
  }

  .btn-wh82p {
    width: 82px;
    height: 82px;
  }

  .btn-wh83p {
    width: 83px;
    height: 83px;
  }

  .btn-wh100 {
    width: 100%;
    height: 100%;
  }

  .btn-CustomWh {
    width: 70px;
    height: 113px;
  }
`;

const Button: FC<IProps> = ({
  className,
  onClick,
  onClickCapture,
  text,
  disabled = false,
  isLoading = false,
  writeAuthYn = 'Y',
  value,
  useExcelIcon = false,
  style = {},
}) => {
  if (writeAuthYn === 'N') return null;

  return (
    <Block>
      <button
        style={style}
        className={className}
        onClick={onClick}
        onClickCapture={onClickCapture}
        disabled={disabled}
      >
        {
          useExcelIcon && (
            <span className="mr-1" style={{ display: 'inline-block', transform: 'translateY(-1px)' }}><RiFileExcel2Line /></span>
          )
        }
        {isLoading ? (
          <>
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            />
            <span className="sr-only">Loading...</span>
          </>
        ) : (
          <>{text}</>
        )}
      </button>
    </Block>
  );
};

export default Button;
